<ion-header>
    <ion-toolbar>
        <ion-title> {{ 'Ball change policy' | translate }}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="dismiss()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-list>
        <ion-item button *ngFor="let bcp of ballChangePolicy" (click)="dismiss(bcp)">
            <ion-label>{{ bcp.description | translate }}</ion-label>
        </ion-item>
    </ion-list>
</ion-content>